import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { Toggle } from '@bingads-webui-react/toggle';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { PropTypeI18n } from './shapes';
import { getToggleStyles } from './util';

const StyledToggleUnwrapped = ({
  isChecked,
  setIsChecked,
  i18n,
  classes,
  className,
}) => {
  const toggleLabelKey = useMemo(() => {
    if (isChecked) {
      return _TL_('On (Recommended)');
    }
    return _TL_('Off');
  }, [isChecked]);
  return (
    <div className={classes.toggleWrapper}>
      <Toggle
        className={className}
        checked={isChecked}
        onChange={setIsChecked}
      />
      <span className={classes.toggleStatus}>{i18n.getString(toggleLabelKey)}</span>
    </div>
  );
};

StyledToggleUnwrapped.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  i18n: PropTypeI18n.isRequired,
  classes: PropTypes.shape({
    toggleWrapper: PropTypes.string,
    toggleStatus: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

StyledToggleUnwrapped.defaultProps = {
  className: undefined,
};

StyledToggleUnwrapped.displayName = 'StyledToggle';

export const StyledToggle = memo(withDefaultStyles(
  StyledToggleUnwrapped,
  getToggleStyles
));
